<template>
    <div>
    <v-card class="card card-pricing card-plain">
        <div class="card-body">

            <v-card-title v-if="title" class="card-title-history">{{$t("File History")}}</v-card-title>

            <v-progress-circular v-if="loading && !small"
                                 style="margin: 30px auto auto;"
                                 :size="200"
                                 :width="7"
                                 color="primary"
                                 indeterminate
            ></v-progress-circular>

            <v-progress-circular v-if="loading && small"
                                 style="margin: 10px auto auto;"
                                 :size="150"
                                 :width="5"
                                 color="primary"
                                 indeterminate
            ></v-progress-circular>

            <v-timeline v-if="!loading" dense>


                <v-timeline-item v-for="action in items" :key="action._id" :color="getActionColor(action)" small>

                    <!-- Title and date -->
                    <template>
                        <h3 style="color: #898b96; font-size: 1.3rem;">{{getActionTitle(action)}}</h3>
                        <span :class="`headline font-weight-bold ${getActionColor(action)}--text`" v-text="$moment(action.date).format('DD-MM-YYYY HH:mm')" ></span>
                    </template>

                    <!-- Description -->
                    <div class="font-weight-bold headline">

                        <div v-if="action.action === 3 && isActionShare(action)">
                            {{ action.from.email }} share with {{action.to.email}}
                        </div>

                        <div v-else-if="action.action === 3 && !isActionShare(action)">
                            {{ action.from.email }} remove access to {{action.to.email}}
                        </div>

                        <div v-else-if="action.actionType === 4">
                            {{ action.from.email }} give multiuser protection to the file
                        </div>

                        <div v-else>
                            By {{action.from.email}}
                        </div>
                    </div>

                    <!-- Transaction -->
                    <p>
                        <a :href="getTxHashUrl(action.transaction.hash)" class="m-link m-link--metal m-timeline-3__item-link  ellipsis" target="_blank" style="display: inherit;">{{action.transaction.hash}}</a>
                    </p>

                    <!-- Permissions -->
                    <div v-if="action.action === 3 && !action.permission.every(function(a){return a===0;})">

                        <strong>{{$t('Permissions:')}}</strong>

                        <br>

                        <span v-if="action.permission[6]">
                            <span class="mr-2" color="success" text-color="white">{{$t('Edit')}}</span>
                        </span>

                        <span v-if="action.permission[5]">
                            <span class="mr-2" color="info" text-color="white">{{$t('View')}}</span>
                        </span>

                        <span v-if="action.permission[4]">
                            <span class="mr-2" color="warning" text-color="white">{{$t('Download')}}</span>
                        </span>

                        <span v-if="action.permission[3]">
                            <span class="mr-2" color="danger" text-color="white">{{$t('Share')}}</span>
                        </span>

                        <span v-if="action.permission[2]">
                            <span class="mr-2" color="metal" text-color="white">{{$t('Print')}}</span>
                        </span>

                        <span v-if="action.permission[1]">
                            <span color="primary" text-color="white">{{$t('Temporary Access')}}</span>
                        </span>

                        <span v-if="action.permission[0]">
                            <span class="mr-2" color="primary" text-color="white">{{$t('Temporary Print Access')}}</span>
                        </span>

                        <span v-if="canRevoke" style="float:right">
                            <v-chip color="secondary" v-model="revokeModel" text-color="white" @click="revokeTo(action.to.email)">{{$t('Revoke')}}</v-chip>
                        </span>

                        <span v-if="canEdit" style="float:right">
                            <v-chip color="secondary" v-model="editModel" text-color="white" @click="editTo(action.to.email)">{{$t('Edit')}}</v-chip>
                        </span>
                    </div>

                </v-timeline-item>

            </v-timeline>
        </div>
    </v-card>

    <v-dialog v-model="showEdit" persistent max-width="500">
        <change-permission :editEmail="editEmail" :hash="hash" :token="token"></change-permission>
    </v-dialog>
    </div>
</template>

<script>
    import { VFlex, VBtn, VCard, VDialog, VTimeline, VTimelineItem, VCardTitle, VChip, VProgressCircular } from 'vuetify/lib';
    import FilesRepository from '../repositories/FilesRepository';
    import ChangePermission from "./SharedFilesCard/ChangePermission";

    export default {
        name: "FileHistory",
        components: {
            ChangePermission,
            VFlex,
            VCard,
            VBtn,
            VTimeline,
            VTimelineItem,
            VCardTitle,
            VChip,
            VProgressCircular,
            FilesRepository,
            VDialog
        },
        props: {
            title: Boolean,
            small: Boolean,
            canRevoke: Boolean,
            hash: String,
            token: String,
            canEdit: Boolean,
        },
        data () {
            return {
                loading: true,
                items: [],
                revokeModel: true,
                editModel: true,
                editEmail: null,
                showEdit: false
            }
        },
        watch: {
            revokeModel: function () {
                if (!this.revokeModel) {
                }
            },
        },
        created() {
            this.$root.$on('close', () => {
                this.showEdit = false;
            })
        },
        methods:{
            getTxHashUrl(hash) {
                return 'https://blockscout.circulartrust.blueroominnovation.com/tx/' + hash;
            },
            isActionShare(action) {
                return !action.permission.every(function(a){return a===0;});
            },
            getActionColor(action) {
                switch(action.action) {
                    case 1: // Create
                        return "success";
                    case 2: // Edit
                        return "info";
                    case 3:
                        if (action.permission.every(function(a){return a===0;})  ){
                            // Unshare
                            return "secondary";
                        }else{
                            // Share
                            return "warning";
                        }
                    case 4: // Multiuser Protection
                        return "info";
                    case 5: // View
                        return "primary";
                    case 6: // Download
                        return "secondary";
                    default:
                        return "";
                }
            },

            getActionTitle(action) {
                switch(action.action) {
                    case 1: // Create
                        return "Create";
                    case 2: // Edit
                        return "Edit";
                    case 3:
                        if (action.permission.every(function(a){return a===0;})  ){
                            // Unshare
                            return "Unshare";
                        }else{
                            // Share
                            return "Share";
                        }
                    case 4: // Multiuser Protection
                        return "Multiuser";
                    case 5: // View
                        return "View";
                    case 6: // Download
                        return "Download";
                    default:
                        return "";
                }
            },

            setItems(actions) {
                this.items = actions;
                this.loading = false;
            },

            editTo(email) {
                this.editEmail = email;
                this.showEdit = true;
            },

            revokeTo(email) {
                var permissionList = [0, 0, 0, 0, 0, 0, 0, 0];
                var temporaryPermissionType = null;
                var temporaryPermissionValue = null;
                var givePermissionList= [0, 0, 0, 0, 0, 0, 0, 0];

                //alert("revoke hash " + this.hash + " token " + this.token + " email " + email);

                FilesRepository.unshareFile(this.hash, [email], "", permissionList, temporaryPermissionType, temporaryPermissionValue, givePermissionList, this.token).then(() => {
                    this.$root.$emit('show-snackbar', {message: "File unshared successfully", color: 'success', timeout: 6000 });
                }).catch((error) => {
                    this.$root.$emit('show-snackbar', {message: "An error occured", color: 'error', timeout: 6000 });
                });
            }
        },
        sockets: {

            NEW_HISTORY(params) {
                // Get the param
                let action = params[0];
                action._id = action.id;

                // Search if the action exists in items
                let found = false;
                for (let item of this.items) {
                    if (item._id === action._id) {
                        found = true;
                        break;
                    }
                }

                // If not found, add the item
                if (!found) {
                    this.items.push(action);
                }
            }

        }
    }
</script>

<style scoped>
    .card {
        overflow: auto;
        height: 100%;
    }
    .card-title {
        margin-top: 30px;
    }
    .card-title {
        margin-bottom: .75rem;
    }
    .circle {
        padding: 5px 20px;
        border-radius: 50%;
        font-size: 50px;
        color: #fff;
    }
    .free-account {
        background: #4DB3C7;
    }
    .professional-account {
        background: #6ACC56;
    }
    .enterprise-account {
        background: #E0196A;
    }
    .card-category, .category {
        text-transform: capitalize;
        font-weight: 400;
        color: #9a9a9a;
        font-size: .7142em;
    }
    .headline {
        font-size: 15px!important;
    }
    .v-timeline{
        padding-top: 0px;
        text-align: left !important;
    }
    .card-title-history{
        text-align: left !important;
        font-size: 20px;
        font-weight: bold;
    }
    .card-body{
        padding: 15px;
        margin-bottom: 15px;
    }
</style>
